import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { WorkspaceIcon } from '@/components/workspace/WorkspaceIcon';
import { usePageTitle } from '@/hooks/usePageTitle';

/**
 * Неизвестный адрес внутри каркаса -- пустое состояние макета-эталона
 * (notFound() в docs/design/frontend-v2/workspace-data.js): иконка поиска,
 * заголовок, пояснение и ссылка на обзор.
 */
export function NotFound() {
	const { t } = useTranslation('common');
	usePageTitle(t('notFound.title'));

	return (
		<div className="ws-empty-state">
			<WorkspaceIcon name="search" size={32} />
			<h1>{t('notFound.title')}</h1>
			<p>{t('notFound.hint')}</p>
			<Link className="ws-btn" to="/overview">
				<WorkspaceIcon name="list" />
				{t('actions.toOverview')}
			</Link>
		</div>
	);
}
